import {useInfiniteQuery} from 'react-query';
import useInfiniteScroll from '../../../utilities/hooks/useInfiniteScroll';
import {
  getDetailedSubBrandList,
  IGetDetailedSubBrandProps,
} from './getDetailedSubBrandList';

type UseGetDetailedSubBrandListProps = {
  brandId?: number;
  enabled?: boolean;
  query?: IGetDetailedSubBrandProps;
};

const useGetDetailedSubBrandList = ({
  brandId,
  enabled = true,
  query,
}: UseGetDetailedSubBrandListProps) => {
  const {
    data: rawData,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery(
    ['get-detailed-sub-brand', brandId, query],
    ({pageParam = 1}) =>
      getDetailedSubBrandList(brandId as number, pageParam, query),
    {
      enabled: !!brandId && enabled,

      getNextPageParam: lastPage => {
        const next = lastPage?.next;

        if (!next) return undefined;

        return Number(new URL(next).searchParams.get('page'));
      },
    },
  );

  const data = rawData?.pages.flatMap(page => page.results) ?? [];

  const loaderRef = useInfiniteScroll({
    isLoading,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  });

  return {
    data,
    isLoading,
    loaderRef,
    isFetchingNextPage,
    hasNextPage,
  };
};

export default useGetDetailedSubBrandList;
